import { getService } from "../../reducers/service";
import { serviceNames } from "../../utils/constants";

export const getEquipmentData = async (id) => {
	const service = await getService(serviceNames.perEquipment);
	return service.get(id);
};

export const updateEquipmentData = async (id, data) => {
	const service = await getService(serviceNames.perEquipment);
	const response = await service.patch(id, data);
	return response;
};

export const getEquipmentTypeOptions = async (dictionary) => {
	const codePerEquipmentTypes = dictionary?.codePerEquipmentTypes || [];

	return codePerEquipmentTypes.map((type) => ({
		label: type?.Code || type?.code,
		value: type?.Code || type?.code,
		ptsCodeId: type?.ptsCodeId,
	}));
};

export const getEquipmentStatusOptions = async (dictionary) => {
	const codePerEquipmentStatus = dictionary?.codePerEquipmentStatus || [];

	return codePerEquipmentStatus.map((status) => ({
		label: status?.Code || status?.code,
		value: status?.Code || status?.code,
		ptsCodeId: status?.ptsCodeId,
		isCheckedOut: status?.CheckOut || false,
	}));
};

export const getEquipmentConditionOptions = async (dictionary) => {
	const codePerEquipmentConditions =
		dictionary?.codePerEquipmentConditions || [];

	return codePerEquipmentConditions.map((condition) => ({
		label: condition?.Code || condition?.code,
		value: condition?.Code || condition?.code,
		ptsCodeId: condition?.ptsCodeId,
	}));
};

export const getEquipmentCategoryOptions = async (dictionary) => {
	const codePerEquipmentCategory = dictionary?.codePerEquipmentCategory || [];

	return codePerEquipmentCategory.map((category) => ({
		label: category?.Code || category?.code,
		value: category?.Code || category?.code,
		ptsCodeId: category?.ptsCodeId,
	}));
};

export const getEquipmentServiceRequirementsOptions = async (dictionary) => {
	const codePerEquipmentServiceRequirements =
		dictionary?.codePerEquipmentServiceRequirements || [];

	return codePerEquipmentServiceRequirements.map((sr) => ({
		label: sr?.Code,
		value: sr?.Code,
		description: sr?.Description,
		ptsCodeId: sr?.ptsCodeId,
		intervalDays: sr?.IntervalDays,
	}));
};

// Generic helper function
const getEquipmentOptions = async (serviceName, userAgency) => {
	const service = await getService(serviceName);
	const response = await service.find({
		query: {
			agencyId: userAgency,
		},
	});

	return response?.map((value) => ({
		label: value,
		value,
	}));
};

// Specific functions using the helper
export const getBrandOptions = (userAgency) =>
	getEquipmentOptions(serviceNames.perEquipmentBrandOptions, userAgency);

export const getStyleOptions = (userAgency) =>
	getEquipmentOptions(serviceNames.perEquipmentStyleOptions, userAgency);

export const getCaliberOptions = (userAgency) =>
	getEquipmentOptions(serviceNames.perEquipmentCaliberOptions, userAgency);

export const getSightsOptions = (userAgency) =>
	getEquipmentOptions(serviceNames.perEquipmentSightsOptions, userAgency);

export const getLocationOptions = (userAgency) =>
	getEquipmentOptions(serviceNames.perEquipmentLocationOptions, userAgency);

export const getPurchasedFromOptions = (userAgency) =>
	getEquipmentOptions(
		serviceNames.perEquipmentPurchasedFromOptions,
		userAgency,
	);
